import { FC } from 'react';
import { CancelSubscriptionFormInputs } from '@/components/streams/cancel-subscription/cancel-subscription-form.tsx';
import {
  CancelSubscriptionModalContent,
  CancelSubscriptionModalContentProps,
} from '@/components/streams/cancel-subscription/cancel-subscription-modal-content.tsx';
import { useCancelStreamSubscription } from '@/components/streams/toggle-paid-stream-subscription/use-cancel-stream-subscription.ts';

export type CancelStreamSubscriptionModalContentProps = {
  streamId: string;
};

export const CancelStreamSubscriptionModalContent: FC<
  CancelStreamSubscriptionModalContentProps &
    CancelSubscriptionModalContentProps
> = ({ streamId, onOpenChange }) => {
  const [cancelStreamSubscription] = useCancelStreamSubscription(streamId);

  const onSubmit = async (input: CancelSubscriptionFormInputs) => {
    await cancelStreamSubscription({
      ...input,
      streamId,
    });
  };

  return (
    <CancelSubscriptionModalContent
      onOpenChange={onOpenChange}
      onSubmit={onSubmit}
    />
  );
};
